import { render, staticRenderFns } from "./mdShoppingArea.vue?vue&type=template&id=780e115d&scoped=true&"
import script from "./mdShoppingArea.vue?vue&type=script&lang=js&"
export * from "./mdShoppingArea.vue?vue&type=script&lang=js&"
import style0 from "./mdShoppingArea.vue?vue&type=style&index=0&id=780e115d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780e115d",
  null
  
)

export default component.exports